export function IntegrationsHeader() {
  return (
    <div className="relative flex w-full content-start justify-between text-left max-800:flex-col-reverse">
      <div>
        <h1 className="mt-0 text-xl font-med">
          Integrate iwocaPay seamlessly in a few clicks
        </h1>
        <div className="text-l font-reg">
          We’ve partnered with the biggest names in ecommerce and accounting
          software to make accepting payments with iwocaPay easy.
        </div>
      </div>
      <div className="shrink-0 text-s font-med max-800:pb-[1.5rem]">
        Need some help?
        <a
          className="pl-s text-primary-40"
          href="https://support.iwoca.co.uk/en/collections/2302041-frequently-asked-questions"
          target="_blank"
          rel="noreferrer"
        >
          Check out our FAQs
        </a>
      </div>
    </div>
  );
}
